// Partner has a customized account if he has at least one field filled
export const isCustomized = (customizations = {}) => {
  if (customizations === null) return false;
  return Object.keys(customizations).length > 0;
};

// Partner has a customized phone
export const hasCustomizedPhone = (customizations = {}) => {
  if (customizations === null) return false;
  return Boolean(customizations.supportPhone);
};



// WEBPACK FOOTER //
// ./src/utils/customization.js